import { render } from "./MinorHead.vue?vue&type=template&id=762e4cca&scoped=true"
import script from "./MinorHead.vue?vue&type=script&lang=js"
export * from "./MinorHead.vue?vue&type=script&lang=js"

import "./MinorHead.vue?vue&type=style&index=0&id=762e4cca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-762e4cca"]])

export default __exports__